// Copyright 2023, Imprivata, Inc.  All rights reserved.
import { Headers } from '../../api/constants';
export { Headers };

export const QueryParamName = {
  CONTEXT_TYPE: 'contextType' as const,
  RESOURCE_TYPE: 'resourceType' as const,
  WINDOW_CLOSE_SEC: 'windowCloseSec' as const,
  DISABLE_AUTO_COMPLETE: 'disableAutoComplete' as const,
  DISABLE_EPCS: 'disableEpcs' as const,
};
